import { Component, OnInit } from '@angular/core';
import { TipPotvrdeOStrucnomUsavrsavanju } from './tip-potvrde-o-strucnom-usavrsavanju';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-tip-potvrde-o-strucnom-usavrsavanju-modal-update',
  templateUrl: './tip-potvrde-o-strucnom-usavrsavanju-modal-update.component.html'
})
export class TipPotvrdeOStrucnomUsavrsavanjuModalUpdateComponent extends BaseModalUpdateComponent<TipPotvrdeOStrucnomUsavrsavanju> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<TipPotvrdeOStrucnomUsavrsavanju>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }
 

  ngOnInit() {
  }

}
